import React from 'react'
import styled from 'styled-components'

import { connect } from 'react-redux'
import { mapLanguageToComponentProps } from 'admin/i18n'
import { I18nComponentType } from 'admin/i18n-types'
import { MenuContextProvider, useMenuContext } from './menu-context'
import { StyledMenuButton } from './menu-item/menu-button'
import { MenuButton } from './menu-item'

export interface MenuProps {
  buttonRef?: React.RefObject<HTMLButtonElement>
  onClose?: () => void
  children?: React.ReactNode
}

export const MenuWrapper = styled.div`
  display: flex;
  flex-direction: column;

  flex-grow: 0;
  width: fit-content;
  min-width: ${({ theme }) => theme.space.s160};
`

const MainMenuButton = styled(MenuButton).attrs({
  icon: 'chevron_left',
  variant: 'basicSecondary',
  textVariant: 'label',
})`
  ${StyledMenuButton} {
    padding-left: 0;
    padding-right: ${({ theme }) => theme.space.s16};
  }

  margin-bottom: ${({ theme }) => theme.space.s8};
`

export const MenuContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  margin: 0;
  padding: 0;
`

export const MenuContentFC: React.FC<
  MenuProps & { i18n: I18nComponentType }
> = ({ i18n, children }) => {
  const { selectedSubMenu, setSelectedSubMenu } = useMenuContext()

  return (
    <MenuWrapper>
      {selectedSubMenu && (
        <MainMenuButton
          closeMenuOnClick={false}
          onClick={() => setSelectedSubMenu(undefined)}
          text={i18n.adminNavigationBar.backToMainMenu || ''}
        />
      )}
      <MenuContentWrapper>{selectedSubMenu || children}</MenuContentWrapper>
    </MenuWrapper>
  )
}

export const MenuContent = connect(mapLanguageToComponentProps())(MenuContentFC)

export const Menu: React.FC<MenuProps> = ({ children, onClose }) => (
  <MenuContextProvider onClose={onClose}>
    <MenuContent>{children}</MenuContent>
  </MenuContextProvider>
)
